import { FC } from 'react';
import { NewBlackFooter } from './BlackFooter';
import { NewGreyFooter } from './GreyFooter';

const BravoFooter: FC = (): JSX.Element => (
  <>
    <NewGreyFooter />
    <NewBlackFooter />
  </>
);

export default BravoFooter;
